'use strict';

/**
 * Bambuser Shopper Events – site-wide listeners.
 *
 * Loaded on every page via the main layout so that add-to-cart,
 * update-cart, product-view and purchase events are captured regardless
 * of whether the shopper is on the live-shopping page.
 *
 * Each tracked element receives a `data-bambuser-event` attribute so
 * duplicate firings are avoided and events are identifiable in the DOM.
 */

var metrics = require('./liveShoppingBambuser/utils/bambuserMetrics');

var ATTR = metrics.CUSTOM_ATTR;

// ---- helpers ----------------------------------------------------------

function getCurrency () {
    var helperEl = document.querySelector('.analytics.helperData');

    if (helperEl && helperEl.getAttribute('data-currency')) {
        return helperEl.getAttribute('data-currency');
    }

    var metaTag = document.querySelector('meta[itemprop="priceCurrency"]');

    if (metaTag) {
        return metaTag.getAttribute('content') || 'EUR';
    }

    return 'EUR';
}

function isBambuserItemFromContext () {
    return document.cookie.indexOf('_bamls_lcte=') !== -1;
}

// ---- add-to-cart ------------------------------------------------------

$(document).ready(function () {
    $('body').on('product:afterAddToCart', function (_event, data) {
        try {
            var items;
            var pliUUID = data.pliUUID || (data.form && data.form.uuid);

            if (data.cart && data.cart.items) {
                items = data.cart.items;
            } else if (data.cartModel && data.cartModel.items) {
                items = data.cartModel.items;
            }

            if (!items || !items.length) {
                return;
            }

            var matched = null;

            if (pliUUID) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].UUID === pliUUID) {
                        matched = items[i];
                        break;
                    }
                }
            }

            if (!matched) {
                matched = items[items.length - 1];
            }

            var quantity = data.form && data.form.quantity ? parseInt(data.form.quantity, 10) : 1;
            var product = metrics.mapProduct(matched, getCurrency());
            product.quantity = quantity;

            metrics.trackAddToCart([product], getCurrency(), isBambuserItemFromContext());
        } catch (e) {
            // fail silently – analytics must never break the page
        }
    });

    // ---- update-cart (quantity change) ---------------------------------

    $('body').on('product:addQuantityFromCart', function (_event, data) {
        try {
            var items;

            if (data.cart && data.cart.items) {
                items = data.cart.items;
            } else if (data.cartModel && data.cartModel.items) {
                items = data.cartModel.items;
            }

            if (!items || !items.length) {
                return;
            }

            var pid = data.form && data.form.pid ? data.form.pid : '';
            var matched = null;

            for (var i = 0; i < items.length; i++) {
                if (items[i].id === pid || items[i].UUID === (data.form && data.form.uuid)) {
                    matched = items[i];
                    break;
                }
            }

            if (!matched) {
                return;
            }

            var product = metrics.mapProduct(matched, getCurrency());
            product.quantity = matched.quantity || 1;

            metrics.trackUpdateCart([product], getCurrency(), isBambuserItemFromContext());
        } catch (e) {
            // fail silently
        }
    });

    // ---- update-cart (removal – quantity 0) ----------------------------

    $('body').on('removeItemFromCartSuccessful', function (_event, data) {
        try {
            if (!data || !data.productData) {
                return;
            }

            var pd = data.productData;
            var product = {
                id: (pd.id || '').toString().split('_')[0].split(' ')[0],
                name: pd.name || '',
                quantity: 0,
                price: parseFloat(pd.price) || 0,
                currency: getCurrency(),
            };

            metrics.trackUpdateCart([product], getCurrency(), isBambuserItemFromContext());
        } catch (e) {
            // fail silently
        }
    });

    // ---- product-view -------------------------------------------------

    var productViewFired = false;

    function fireProductView () {
        if (productViewFired) {
            return;
        }

        var analyticsEl = document.querySelector('.analytics.product');

        if (!analyticsEl) {
            return;
        }

        productViewFired = true;
        analyticsEl.setAttribute(ATTR, 'product-view');

        var product = {
            id: analyticsEl.getAttribute('data-item_id') || '',
            name: analyticsEl.getAttribute('data-item_name') || '',
            quantity: 1,
            price: parseFloat(analyticsEl.getAttribute('data-price')) || 0,
            currency: getCurrency(),
            category: analyticsEl.getAttribute('data-item_category') || '',
            brand: analyticsEl.getAttribute('data-item_brand') || '',
            location: window.location.href,
        };

        metrics.trackProductView([product], getCurrency(), isBambuserItemFromContext());
    }

    // Fire on PDP pages
    if ($('.page[data-action="Product-Show"]').length > 0 ||
        $('.page[data-action="Product-ShowInCategory"]').length > 0) {
        fireProductView();
    }

    // ---- purchase (order confirmation) --------------------------------

    var purchaseEl = document.querySelector('.js-bambuserPurchaseData');

    if (purchaseEl) {
        try {
            var purchaseData = JSON.parse(purchaseEl.getAttribute('data-bambuser-purchase'));

            if (purchaseData && purchaseData.transaction && purchaseData.products) {
                purchaseEl.setAttribute(ATTR, 'purchase');
                metrics.trackPurchase(purchaseData.transaction, purchaseData.products);
            }
        } catch (e) {
            // fail silently
        }
    }

    // ---- refund (return confirmation) ---------------------------------

    var refundEl = document.querySelector('.js-bambuserRefundData');

    if (refundEl) {
        try {
            var refundData = JSON.parse(refundEl.getAttribute('data-bambuser-refund'));

            if (refundData && refundData.transaction && refundData.products) {
                refundEl.setAttribute(ATTR, 'refund');
                metrics.trackRefund(refundData.transaction, refundData.products);
            }
        } catch (e) {
            // fail silently
        }
    }
});
